var map = {
	"./blog-01.jpg": 61290,
	"./blog-02.jpg": 55928,
	"./blog-03.jpg": 51491,
	"./blog-04.jpg": 30402,
	"./blog-05.jpg": 79915,
	"./blog-06.jpg": 18172
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97497;